<template>
  <div class="mine">
    <div class="mine-bgCircle"></div>
    <!-- <img class="mine-bgCircle" src="../assets/images/mine_bgCircle.png" alt="bgCircle" /> -->
    <div class="mine-main" ref="stage">
      <mine-head :data="learnInfo" :userInfo="userInfo" />

      <mine-option-list @closeLayer="closeLayer" :data-source="optionList" />

      <mine-option-list @closeLayer="closeLayer" :data-source="helpOptionList" />
    </div>
  </div>
</template>

<script>
/** eslint-disable */
import api from '@edu-fe/api'
import os from '@edu-fe/os'
import MineHead from '../components/Mine/Head.vue'
import MineOptionList from '../components/Mine/OptionList.vue'
import ShareMaker from '../lib/shareMaker'
import { isxxx } from '@mixins'
import iconBell from '../assets/icons/mine-icon-bell.png'
import iconAccount from '../assets/icons/mine-icon-account.png'
import iconCoupon from '../assets/icons/mine-icon-coupon.png'
import iconMessage from '../assets/icons/mine-icon-message.png'
import iconPrivilege from '../assets/icons/icon_privilege.png'
import iconTemplate from '../assets/icons/mine-icon-template.png'
import iconPrize from '../assets/icons/icon-prize.png'
import login from '@/utils/login'

export default {
  name: 'Mine',
  props: {
    learnInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    couponList: {
      type: Array
    },
    isPrivilege: {
      type: Number
    }
  },
  mixins: [isxxx],
  data () {
    return {
      couponcount: 0,
      optionList: [
        // {
        //   name: '我的课程',
        //   icon: iconCourse,
        //   href: '/mine/course'
        // },
        {
          name: '我的代金券',
          icon: iconCoupon,
          href: '/mine/coupon'
        },
        {
          name: '我的兑换',
          icon: iconPrize,
          href: '/exchange'
        }
      ],
      helpOptionList: [
        {
          name: '帮助与反馈',
          icon: iconMessage,
          href: '/mine/help'
        }
      ],
      userInfo: '',
    }
  },

  methods: {
    closeLayer () {
      window.localStorage.setItem('isLayerVisible', 'true')
    }
  },
  watch: {
    couponCount: {
      handler (e) {
        this.optionList.splice(0, 1, {
          name: '我的代金券',
          icon: iconCoupon,
          href: '/mine/coupon',
          hasPoint: e
        })
      },
      immediate: true
    }
  },
  computed: {
    couponCount () {
      return this.couponList.length
    },
    isAli () {
      return os.type === 'ali'
    }
  },
  components: {
    MineHead,
    MineOptionList,
  },
  async created () {
    await login.login()
    const userData = await api.mine.userInfo()
    this.userInfo = userData.data
    if (os.type === 'weixin') {
      this.optionList.push({
        name: '消息提醒',
        icon: iconBell,
        href: '/custom-time'
      })
    }
  },

  mounted () {
    // eslint-disable-next-line no-new
    new ShareMaker(
      {
        title: '微课',
        introduction:
          '职业的发展取决于，工作8小时之外的学习，微课助力职场，成就精英！',
        imgUrl: this.$store.state.organizationMessage.organLogo,
        link: `https://course-m.auoktalk.com/recommend/?appId=${window.localStorage.getItem('wkAppId')}`
      },
      location.href,
      true
    )
  }
}
</script>
<style lang="scss">
html,
body,
#app {
  height: 100%;
}
</style>
<style lang="scss" scoped>
@charset "UTF-8";
@import "../style/main";
.mine {
  position: relative;
  height: 100%;
  width: 100%;
  background-color: rgb(243, 244, 246);
  position: relative;
  &-main {
    box-sizing: border-box;
    overflow-y: scroll;
    // overflow: auto;
    position: absolute;
    top: 0;
    left: 0;
    padding-bottom: rem(100);
    width: 100%;
    height: 100%;
    &-privilege {
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: rem(695);
      background-color: #fff;
      border-radius: 4px;
      /*height: rem(100);*/
      box-shadow: 0 rem(12) rem(15) rgba(0, 0, 0, 0.2);
      margin: auto;
      > img {
        width: 100%;
      }
      > p {
        font-size: rem(30);
        color: $globalColor;
      }
      &-btn {
        width: rem(162);
        height: rem(50);
        background: $globalColor;
        border-radius: rem(25);
        color: white;
        text-align: center;
        line-height: rem(50);
      }
    }
  }

  &-detect {
    width: 100%;
    height: 0;
  }

  &-bgCircle {
    width: 100%;
    height: rem(269);
    background: $globalColor;
    border-radius: 0 0 50% 50%;
  }

  &-contact {
    text-align: center;
    padding-bottom: rem(98);

    img {
      height: rem(50);
      width: rem(158);
      margin-top: rem(60);
    }
  }
  &-customer {
    position: fixed;
    right: 5%;
    bottom: 23.7vh;
    z-index: 99;
  }
}
</style>
